var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useMemo, useState } from 'react';
import { GBThemeWrapper } from '@leapfinance/geebee-component-library';
import { FormControlLabel, FormGroup, FormHelperText, Typography } from '@mui/material';
import MuiCheckBox from '@mui/material/Checkbox';
import EditableInputWrapperV2 from '../../EditableInputWrapperV2';
import LabelWrapper from '../LabelWrapper';
import TextInput from './TextInput';
var Checkbox = function (_a) {
    var _b, _c;
    var editable = _a.editable, required = _a.required, label = _a.label, disabled = _a.disabled, displayValue = _a.displayValue, formControlLabelProps = _a.formControlLabelProps, value = _a.value, onChange = _a.onChange, error = _a.error, helperText = _a.helperText, _d = _a.options, options = _d === void 0 ? [] : _d, formGroupProps = _a.formGroupProps, searchable = _a.searchable, searchTextFieldProps = _a.searchTextFieldProps, _e = _a.optionsWrapperHeight, optionsWrapperHeight = _e === void 0 ? 200 : _e, renderLabel = _a.renderLabel, getDisableOption = _a.getDisableOption, singleSelect = _a.singleSelect, groupOptions = _a.groupOptions, _f = _a.searchAndOptionsContainerClassNames, searchAndOptionsContainerClassNames = _f === void 0 ? '' : _f, formGroupContainerClassNames = _a.formGroupContainerClassNames, renderCustomHeader = _a.renderCustomHeader, _g = _a.sortSelected, sortSelected = _g === void 0 ? false : _g;
    var _h = __read(useState(singleSelect ? null : []), 2), values = _h[0], setValues = _h[1];
    var _j = __read(useState(options !== null && options !== void 0 ? options : []), 2), filteredOptions = _j[0], setFilteredOptions = _j[1];
    useEffect(function () {
        if (typeof value === 'undefined') {
            setValues(singleSelect ? null : []);
        }
        else {
            setValues(value);
        }
    }, [value, singleSelect]);
    useEffect(function () {
        setFilteredOptions(options);
    }, [options]);
    var handleCheck = function (event, checked) {
        try {
            var eventValue_1 = JSON.parse(event.target.value);
            var newValues = void 0;
            if (checked) {
                newValues = singleSelect ? eventValue_1 : __spreadArray(__spreadArray([], __read(values), false), [eventValue_1], false);
            }
            else {
                newValues = singleSelect ? null : values.filter(function (val) { return (val === null || val === void 0 ? void 0 : val.value) !== (eventValue_1 === null || eventValue_1 === void 0 ? void 0 : eventValue_1.value); });
            }
            setValues(newValues);
            onChange === null || onChange === void 0 ? void 0 : onChange(newValues);
        }
        catch (error) { }
    };
    var handleSearch = function (event) {
        var _a;
        if (!((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value)) {
            setFilteredOptions(options);
            return;
        }
        setFilteredOptions(options.filter(function (op) { var _a, _b, _c; return (_b = (_a = op.label) === null || _a === void 0 ? void 0 : _a.toString().toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes((_c = event === null || event === void 0 ? void 0 : event.target.value) === null || _c === void 0 ? void 0 : _c.trim().toLowerCase()); }));
    };
    var startsWithNumberOrSpecialCharacter = function (label) {
        return /[^a-zA-Z0-9]/.test(label);
    };
    var getGrouping = function (options) {
        var groupMap = new Map();
        options.forEach(function (option) {
            var _a;
            if (!(option === null || option === void 0 ? void 0 : option.label))
                return;
            var firstLetter = option.label.toString()[0];
            if (startsWithNumberOrSpecialCharacter(firstLetter)) {
                firstLetter = '#';
            }
            if (groupMap.has(firstLetter)) {
                var existingOptions = (_a = groupMap.get(firstLetter)) !== null && _a !== void 0 ? _a : [];
                groupMap.set(firstLetter, __spreadArray(__spreadArray([], __read(existingOptions), false), [option], false));
            }
            else {
                groupMap.set(firstLetter, [option]);
            }
        });
        var groupedOptions = [];
        // eslint-disable-next-line @typescript-eslint/require-array-sort-compare
        var sortedMap = new Map(__spreadArray([], __read(groupMap), false).sort());
        sortedMap.forEach(function (data, key) {
            groupedOptions.push({ label: String(key), value: String(key), type: 'header' });
            var restOptions = data.map(function (op) { return (__assign(__assign({}, op), { headerLabel: String(key) })); });
            groupedOptions.push.apply(groupedOptions, __spreadArray([], __read(restOptions), false));
        });
        return groupedOptions;
    };
    var handleGroupedNavigation = function (headerLabel) {
        var _a;
        (_a = document
            .getElementById("grouped-header-".concat(headerLabel))) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'center' });
    };
    var groupedOptions = useMemo(function () { return getGrouping(filteredOptions); }, [filteredOptions]);
    var desiredOptions = groupOptions ? groupedOptions : filteredOptions;
    return (React.createElement(GBThemeWrapper, null,
        React.createElement(LabelWrapper, { label: label, disabled: disabled, required: required },
            React.createElement(EditableInputWrapperV2, { editable: editable, value: displayValue === null || displayValue === void 0 ? void 0 : displayValue(values) },
                React.createElement("div", { className: searchAndOptionsContainerClassNames },
                    searchable &&
                        ((_c = renderCustomHeader === null || renderCustomHeader === void 0 ? void 0 : renderCustomHeader({
                            onChange: handleSearch,
                            headerLabelList: (_b = groupedOptions === null || groupedOptions === void 0 ? void 0 : groupedOptions.filter(function (op) { return (op === null || op === void 0 ? void 0 : op.type) === 'header'; })) === null || _b === void 0 ? void 0 : _b.map(function (op) { return op === null || op === void 0 ? void 0 : op.label; }),
                            naviagateToHeader: handleGroupedNavigation
                        })) !== null && _c !== void 0 ? _c : React.createElement(TextInput, __assign({}, searchTextFieldProps, { type: "text", onChange: handleSearch }))),
                    React.createElement("div", { style: formGroupContainerClassNames ? {} : { maxHeight: searchable ? optionsWrapperHeight : 'auto' }, className: formGroupContainerClassNames !== null && formGroupContainerClassNames !== void 0 ? formGroupContainerClassNames : (searchable ? ' lfc-overflow-y-scroll lfc-p-2' : '') },
                        searchable && filteredOptions.length === 0 && (React.createElement("div", { className: "lfc-p-2" },
                            React.createElement(Typography, { variant: "body2" }, "No Options"))),
                        React.createElement(FormGroup, __assign({ key: filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length }, formGroupProps), desiredOptions.map(function (option) {
                            var _a, _b;
                            return (option === null || option === void 0 ? void 0 : option.type) === 'header' ? (React.createElement(Typography, { className: "p-[9x] GroupHeaderLabel GroupedCheckboxOption OptionOfGroup-".concat(option === null || option === void 0 ? void 0 : option.label), variant: "caption1", fontWeight: 700, id: "grouped-header-".concat(option.label) }, option.label)) : (React.createElement(FormControlLabel, __assign({ disabled: getDisableOption === null || getDisableOption === void 0 ? void 0 : getDisableOption(option), key: String(option.value), control: React.createElement(MuiCheckBox, { checked: singleSelect
                                        ? (values === null || values === void 0 ? void 0 : values.value) === option.value
                                        : values.map(function (op) { return op.value; }).includes(option.value) }), label: (_a = renderLabel === null || renderLabel === void 0 ? void 0 : renderLabel(option)) !== null && _a !== void 0 ? _a : option.label, value: JSON.stringify(option) }, formControlLabelProps, { className: "CheckboxOption ".concat(groupOptions ? "GroupedCheckboxOption OptionOfGroup-".concat(option === null || option === void 0 ? void 0 : option.headerLabel) : '', " ").concat((_b = formControlLabelProps === null || formControlLabelProps === void 0 ? void 0 : formControlLabelProps.className) !== null && _b !== void 0 ? _b : ''), onChange: function (event, checked) {
                                    var _a;
                                    handleCheck(event, checked);
                                    (_a = formControlLabelProps === null || formControlLabelProps === void 0 ? void 0 : formControlLabelProps.onChange) === null || _a === void 0 ? void 0 : _a.call(formControlLabelProps, event, checked);
                                } })));
                        }))),
                    helperText && React.createElement(FormHelperText, { error: error }, helperText))))));
};
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map